import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Quote } from 'lucide-react';
import { Button } from '../components/ui/button';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Results = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true
    });
  }, []);

  return (
    <div className="results-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="display-large" data-aos="fade-up">Client Transformations</h1>
          <p className="body-large" data-aos="fade-up" data-aos-delay="100">
            Real people. Real results. Real transformations.
          </p>
        </div>
      </section>

      {/* Intro Section */}
      <section className="results-intro-section">
        <div className="container">
          <div className="results-intro-content" data-aos="fade-up">
            <h2 className="heading-1">Success Stories Coming Soon</h2>
            <p className="body-large">
              I'm incredibly proud of the transformations my clients have achieved. From significant 
              weight loss to competition-ready physiques, each journey is unique and inspiring.
            </p>
            <p className="body-medium">
              Currently, I'm collecting client consent and testimonials to showcase their amazing 
              transformations here. Check back soon to see real before-and-after photos and read 
              inspiring success stories from people just like you.
            </p>
          </div>
        </div>
      </section>

      {/* Placeholder Cards */}
      <section className="results-grid-section">
        <div className="container">
          <div className="results-grid">
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <div 
                key={item} 
                className="result-placeholder-card"
                data-aos="fade-up"
                data-aos-delay={item * 100}
              >
                <div className="placeholder-image">
                  <div className="placeholder-text">
                    <Quote size={48} />
                    <p className="body-medium">Client Transformation</p>
                    <p className="caption">Before & After Photos</p>
                  </div>
                </div>
                <div className="placeholder-content">
                  <h3 className="heading-3">Client Success Story</h3>
                  <p className="body-small">Testimonial and transformation details coming soon</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What Clients Say Section */}
      <section className="testimonials-preview-section">
        <div className="container">
          <h2 className="heading-1 text-center" data-aos="fade-up">What to Expect</h2>
          <p className="body-large text-center mb-8" data-aos="fade-up" data-aos-delay="100">
            When you train with me, you'll get more than just workouts
          </p>
          
          <div className="expectations-grid">
            <div className="expectation-card" data-aos="fade-up" data-aos-delay="200">
              <h3 className="heading-3">Personalized Approach</h3>
              <p className="body-medium">
                Every client receives a completely customized program based on their unique goals, 
                lifestyle, and fitness level.
              </p>
            </div>
            
            <div className="expectation-card" data-aos="fade-up" data-aos-delay="300">
              <h3 className="heading-3">Ongoing Support</h3>
              <p className="body-medium">
                Beyond training sessions, you'll have access to nutrition guidance, accountability 
                check-ins, and motivational support.
              </p>
            </div>
            
            <div className="expectation-card" data-aos="fade-up" data-aos-delay="400">
              <h3 className="heading-3">Measurable Progress</h3>
              <p className="body-medium">
                Regular assessments and progress tracking ensure you're always moving toward 
                your goals with data-driven adjustments.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="results-cta-section">
        <div className="container">
          <div className="results-cta-content" data-aos="fade-up">
            <h2 className="display-medium">Your Transformation Starts Here</h2>
            <p className="body-large">
              Join my growing community of successful clients achieving their fitness goals.
            </p>
            <Link to="/contact">
              <Button className="btn-cta">
                Book Your Free Consultation
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Results;
